import { CommonModule } from '@angular/common'
import { AfterViewInit, Component, HostListener, ViewChild } from '@angular/core'
import { FormsModule } from '@angular/forms'
import { ActivatedRoute } from '@angular/router'
import { NzButtonModule } from 'ng-zorro-antd/button'
import { NzDividerModule } from 'ng-zorro-antd/divider'
import { NzGridModule } from 'ng-zorro-antd/grid'
import { NzIconModule } from 'ng-zorro-antd/icon'
import { NzModalModule } from 'ng-zorro-antd/modal'
import { NzNotificationService } from 'ng-zorro-antd/notification'
import { NzProgressModule } from 'ng-zorro-antd/progress'
import { NzSelectModule } from 'ng-zorro-antd/select'
import { map, mergeMap, of, take } from 'rxjs'
import Swiper from 'swiper'
import { AtomModule } from '../../atom/atom.module'
import { CartService } from '../../service/cart.service'
import { ProductDetailsService } from '../../service/product-details.service'
import { ReadMorePipe } from '../../utils/pipes/read-more.pipe'

interface Review {
  name: string
  role: string
  content: string
  date: string
  rating: number
}

interface CriticReview {
  publication: string
  logo?: string
  reviewer: string
  score: string
  maxScore: string
  content: string
}

@Component({
  selector: 'app-product-details',
  templateUrl: './product-details.component.html',
  styleUrl: './product-details.component.less',
  providers: [ReadMorePipe],
  standalone: true,
  imports: [
    AtomModule,
    NzDividerModule,
    NzSelectModule,
    NzButtonModule,
    NzGridModule,
    CommonModule,
    FormsModule,
    NzIconModule,
    NzProgressModule,
    NzModalModule,
  ],
})
export class ProductDetailsComponent implements AfterViewInit {
  // Critics review section data
  criticTopScore = 83
  criticRecommendPercentage = 90
  criticBrandLogo =
    'https://storage.googleapis.com/dev-assets.keys7.com/strong.png' // Placeholder for the actual logo

  formatCriticTopScore = () => `${this.criticTopScore}`
  formatCriticRecommendPercentage = () => `${this.criticRecommendPercentage}%`

  criticReviews: CriticReview[] = [
    {
      publication: 'PC GAMER',
      reviewer: 'Mollie Taylor',
      score: '85',
      maxScore: '100',
      content:
        'Two Point Museum is the coolest, coziest, and most evolved iteration of the formula to date, even if its more obtuse aspects prevented me from becoming a pro curator.',
    },
    {
      publication: 'EUROGAMER',
      reviewer: 'Christian Donlan',
      score: '4',
      maxScore: '5',
      content:
        'Come for the clowns and cavemen, stay for the zombie capitalism.',
    },
    {
      publication: 'IGN',
      reviewer: 'Leana Hafer',
      score: '9',
      maxScore: '10.0',
      content:
        'Two Point Museum is a rewarding, deep, challenging, and highly entertaining tycoon game with lots of variety and an excellent interface.',
    },
    {
      publication: 'PC GAMER',
      reviewer: 'Mollie Taylor',
      score: '85',
      maxScore: '100',
      content:
        'Two Point Museum is the coolest, coziest, and most evolved iteration of the formula to date, even if its more obtuse aspects prevented me from becoming a pro curator.',
    },
    {
      publication: 'EUROGAMER',
      reviewer: 'Christian Donlan',
      score: '4',
      maxScore: '5',
      content:
        'Come for the clowns and cavemen, stay for the zombie capitalism.',
    },
    {
      publication: 'IGN',
      reviewer: 'Leana Hafer',
      score: '9',
      maxScore: '10.0',
      content:
        'Two Point Museum is a rewarding, deep, challenging, and highly entertaining tycoon game with lots of variety and an excellent interface.',
    },
  ]
  isOverviewExpanded = false
  isVisualsExpanded = false
  overviewTextLimit = 200
  descriptionTextLimit = 400
  overviewDescription =
    'Explore romance as you match with alluring Sims and plan exciting dates in The Sims™ 4 Lovestruck Expansion Pack. Create your Sim’s profile for the Cupid’s Corner dating app, and start meeting matches! New intimate interactions will unlock as you progress through the game.'

  // Product selection options
  selectedPlatform = 'ea_app'
  selectedEdition = 'standard'
  selectedRegion = 'global'
  discountPercentage = 23

  product$ = this.productDetails.productStore$

  overallReviewData = Array(72)
    .fill(0)
    .map(() => Math.floor(Math.random() * 15000))
  recentReviewData = Array(72)
    .fill(0)
    .map(() => Math.floor(Math.random() * 500))

  playOptions = [
    {
      iconType: 'single-player',
      featureName: 'Single Player',
    },
    {
      iconType: 'online-pvp',
      featureName: 'Online PVP',
    },
    {
      iconType: 'online-co_op',
      featureName: 'Online Co-Op',
    },
    {
      iconType: 'xbox-support',
      featureName: 'Xbox Controller Support',
    },
    {
      iconType: 'dualshock-support',
      featureName: 'DualShock Controller Support',
    },
    {
      iconType: 'dualsense-support',
      featureName: 'DualSense Controller Support',
    },
  ]

  // modal logic for customer reviews section
  isVisible = false
  toggleModal(): void {
    this.isVisible = !this.isVisible
  }

  closeModal(): void {
    this.isVisible = false
  }

  // Gallery image modal logic
  isGalleryModalVisible = false
  selectedGalleryImage = ''
  currentImageIndex = 0

  openGalleryModal(imageSrc: string): void {
    console.log({ imageSrc })
    this.selectedGalleryImage = imageSrc
    this.isGalleryModalVisible = true
    
    // Find the index of the selected image
    this.currentImageIndex = this.dummyImages.findIndex(img => img === imageSrc)
    if (this.currentImageIndex === -1) {
      this.currentImageIndex = 0
    }
    
    console.log('Current image index:', this.currentImageIndex)
  }

  closeGalleryModal(): void {
    this.isGalleryModalVisible = false
  }
  
  showNextImage(): void {
    this.currentImageIndex = (this.currentImageIndex + 1) % this.dummyImages.length
    this.selectedGalleryImage = this.dummyImages[this.currentImageIndex]
  }
  
  showPrevImage(): void {
    this.currentImageIndex = (this.currentImageIndex - 1 + this.dummyImages.length) % this.dummyImages.length
    this.selectedGalleryImage = this.dummyImages[this.currentImageIndex]
  }
  
  @HostListener('document:keydown', ['$event'])
  handleKeyboardEvent(event: KeyboardEvent): void {
    if (this.isGalleryModalVisible) {
      switch (event.key) {
        case 'ArrowRight':
          this.showNextImage()
          break
        case 'ArrowLeft':
          this.showPrevImage()
          break
        case 'Escape':
          this.closeGalleryModal()
          break
      }
    }
  }

  // swiper breakpoints for configurations section
  configSwiperBreakpoints = {
    425: { slidesPerView: 1.2 },
    540: { slidesPerView: 1.5 },
  }

  // swiper breakpoints for reviews section
  reviewsSwiperBreakpoints = {
    540: { slidesPerView: 1.5, spaceBetween: 10 },
    768: { slidesPerView: 2, spaceBetween: 12 },
  }
  // dummy data for reviews section
  reviews: Review[] = [
    {
      name: 'Sarah Johnson',
      role: 'Blogger',
      content:
        "I was a little hesitant to switch to a new web hosting company, but I'm glad I took the plunge. The control panel is user-friendly and I love the one-click installation for popular apps. Everything has been smooth sailing since I made the switch.",
      date: '08 August 2024',
      rating: 5,
    },
    {
      name: 'Sarah Johnson',
      role: 'Blogger',
      content:
        "I was a little hesitant to switch to a new web hosting company, but I'm glad I took the plunge. The control panel is user-friendly and I love the one-click installation for popular apps. Everything has been smooth sailing since I made the switch.",
      date: '08 August 2024',
      rating: 5,
    },
    {
      name: 'Sarah Johnson',
      role: 'Blogger',
      content:
        "I was a little hesitant to switch to a new web hosting company, but I'm glad I took the plunge. The control panel is user-friendly and I love the one-click installation for popular apps. Everything has been smooth sailing since I made the switch.",
      date: '08 August 2024',
      rating: 5,
    },
    {
      name: 'Sarah Johnson',
      role: 'Blogger',
      content:
        "I was a little hesitant to switch to a new web hosting company, but I'm glad I took the plunge. The control panel is user-friendly and I love the one-click installation for popular apps. Everything has been smooth sailing since I made the switch.",
      date: '08 August 2024',
      rating: 5,
    },
    {
      name: 'Sarah Johnson',
      role: 'Blogger',
      content:
        "I was a little hesitant to switch to a new web hosting company, but I'm glad I took the plunge. The control panel is user-friendly and I love the one-click installation for popular apps. Everything has been smooth sailing since I made the switch.",
      date: '08 August 2024',
      rating: 5,
    },
  ]

  // visuals gallery logic
  @ViewChild('thumbnailSwiper') thumbnailSwiper
  mainSwiper: Swiper | undefined
  currentIndex = 0
  dummyImages: string[] = [
    'https://storage.googleapis.com/dev-assets.keys7.com/cyberpunk-2077-pc-game-gog-com-wallpaper-5__preview.jpg',
    'https://storage.googleapis.com/dev-assets.keys7.com/cyberpunk-2077-pc-game-gog-com-wallpaper-4__preview.jpg',
    'https://storage.googleapis.com/dev-assets.keys7.com/cyberpunk-2077-pc-game-gog-com-wallpaper-3__preview.jpg',
    'https://storage.googleapis.com/dev-assets.keys7.com/cyberpunk-2077-pc-game-gog-com-wallpaper-2__preview.jpg',
    'https://storage.googleapis.com/dev-assets.keys7.com/cyberpunk-2077-pc-game-gog-com-wallpaper-1__preview.jpg',
    'https://storage.googleapis.com/dev-assets.keys7.com/warhammer-40-000-space-marine-2-pc-spiel-steam-wallpaper-5__preview.jpg',
    'https://storage.googleapis.com/dev-assets.keys7.com/warhammer-40-000-space-marine-2-pc-spiel-steam-wallpaper-1__preview.jpg',
    'https://storage.googleapis.com/dev-assets.keys7.com/warhammer-40-000-space-marine-2-pc-spiel-steam-wallpaper-2__preview.jpg',
    'https://storage.googleapis.com/dev-assets.keys7.com/warhammer-40-000-space-marine-2-pc-spiel-steam-wallpaper-3__preview.jpg',
  ]

  constructor(
    private route: ActivatedRoute,
    private notificationService: NzNotificationService,
    private cartService: CartService,
    public productDetails: ProductDetailsService,
    private readMorePipe: ReadMorePipe
  ) {
    this.getProduct()
  }

  getProduct() {
    this.route.params.subscribe((params) => {
      const slug = params['slug']
      if (slug) {
        this.productDetails.fetchProduct(slug).subscribe()
      }
    })
  }

  ngAfterViewInit() {
    // Adding more dummy images to ensure we have enough for infinite loop
    this.dummyImages = [
      ...this.dummyImages,
      ...this.dummyImages,
      ...this.dummyImages,
    ]

    setTimeout(() => {
      this.mainSwiper = new Swiper('.main-swiper', {
        slidesPerView: 4,
        spaceBetween: 16,
        grabCursor: true,
        loop: true,
        speed: 500,
        centeredSlides: false,
        navigation: {
          nextEl: '.product__gallery-nav--next',
          prevEl: '.product__gallery-nav--prev',
        },
        breakpoints: {
          0: {
            slidesPerView: 1.2,
          },
          576: {
            slidesPerView: 2.2,
          },
          768: {
            slidesPerView: 3.2,
          },
          992: {
            slidesPerView: 4,
          },
        },
        on: {
          slideChange: (swiper: any) => {
            if (swiper && typeof swiper.realIndex !== 'undefined') {
              this.currentIndex = swiper.realIndex
            }
          },
        },
      })
    }, 0)

    // We don't need the thumbnail swiper for this gallery implementation
    // as we're using dots for pagination instead
  }

  goToNextSlide() {
    this.mainSwiper?.slideNext()
  }

  goToPrevSlide() {
    this.mainSwiper?.slidePrev()
  }

  goToSlide(index: number) {
    this.mainSwiper?.slideTo(index, 0)
  }

  toggleOverviewReadMore() {
    this.isOverviewExpanded = !this.isOverviewExpanded
  }

  toggleVisualsReadMore() {
    this.isVisualsExpanded = !this.isVisualsExpanded
  }

  truncatedDescription(description): string {
    return this.readMorePipe.transform(description, this.descriptionTextLimit)
      .text
  }

  toggleExpand(): void {
    this.isVisualsExpanded = !this.isVisualsExpanded // Toggle state
  }

  // FAQ section
  openFaqIndex: number | null = null

  toggleFaq(index: number): void {
    if (this.openFaqIndex === index) {
      this.openFaqIndex = null
    } else {
      this.openFaqIndex = index
    }
  }

  addItemToOrder() {
    this.product$
      .pipe(
        take(1),
        map((product) => {
          console.log({ product })
          return product?.variants?.[0]
        }),
        mergeMap((productVariant) => {
          console.log(`productVariant: ${productVariant}`)
          if (!productVariant) {
            return of(null)
          }
          return this.cartService.addToCart(productVariant)
        })
      )
      .subscribe((response) => {
        if (response) {
          console.log('Product added to cart:', response)
          this.notificationService.success('Success', 'Product added to cart')
        }
      })
  }
}
